import { Route } from 'vue-router';
import router from './router';
import store from './store';
import { getToken } from './utils/storage';

router.beforeEach(async (to: Route, _: Route, next: any) => {
  if (to.meta.requireAuth !== undefined && to.meta.requireAuth === false) {
    next();
  } else if (store.getters['user/token']) {
    next();
  } else if (getToken()) {
    store
      .dispatch('user/resumeLogin')
      .then(() => next())
      .catch(() => next('/login'));
  } else {
    next('/login');
  }
});
